import React from 'react';
import LoggedInPage from '../../views/core/LoggedInPage';
import profileBg from '../../images/patterns/profilebg.png';
import lessonmenuicon  from '../../images/icons/lessonmenuicon.png';
import lessonmenuiconwhite from '../../images/icons/lessonmenuiconwhite.png';
import sidebar_props from '../../model/AppConstants.js';
import HmAjax from '../../util/HmAjax';
import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import UserStorageUtil from '../../util/UserStorageUtil';
import ChooseGrade from './ChooseGrade';
import "../../css/Sidebar.css";
import 'react-dropdown/style.css';
import $ from 'jquery';
import ComponentRegistry from '../../model/ComponentRegistry';
import HmEventRegistry from '../../model/HmEventRegistry';
import menusJson from '../../config/sidebarMenus.json';

/**
* IMPORTANT: This enables/disables based on contestHost
*
*/
const sidebar_contest_host_driven = true;

let menus = sidebar_props.menus;
const messageView = "messageView";
const noProductView = "noProductView";
const homeView = "homeView";
export default class Sidebar extends LoggedInPage {
	
	constructor(props) {
		super(props);

		this.state = {
			selectedID:0,
			userName:this.getUser().getUserName(),
			imagePreviewUrl:"",
			imageLoaded:false,
			productArr:[],
			gradeArr:[],
			productExpired:false,
			noProducts:false,
			view: homeView,
			lessonIconDisplay:lessonmenuicon,
			grademodalShow:false,
			grademodalTitle:"Test",
			grademodalContent:""
		}

		this.openProfile = this.openProfile.bind(this);
		this.sideBarDropdownChange = this.sideBarDropdownChange.bind(this);
		this.handleMouseOver = this.handleMouseOver.bind(this);
		this.handleMouseOut = this.handleMouseOut.bind(this);
		this.gradeChangefromChooseGrade = this.gradeChangefromChooseGrade.bind(this);
		this.showHideLeftMenu = this.showHideLeftMenu.bind(this);

		this.accessId = 0;
		this.gradeProductMap = {};
		this.classDefnMap={};
		this.selectedGradeOption = null;
		this.selectedProductOption = null;
		this.comboNamesLoaded = false;
		this.gradeStore = null;
		this.homeDropDownKey = "homeDropdown";
		this.preferredGrade = null;
		this.preferredMenuId = null;
		this.preferredProduct = null;
		this.gradeStore = null;

		this.selectedMenu = null;
		this.availableMenuIds = new Set();
		this.entlKey = null;

		this.getProductCount = this.getProductCount.bind(this);
		this.showFormobile=this.showFormobile.bind(this);
		this.getMenusFromJson = this.getMenusFromJson.bind(this);

		this.goTo = this.goTo.bind(this);
	}

	updateUserName(username){
		this.setState({userName:username});
	}

	componentDidMount(){
		var me = this;
		this.props.onRef(this);	
		//this.loadCurrentImage();

		this.setState({selectedID:0});
		
		if(this.productsAvailableToAccess()){
			this.setPreferredDd();
			if(this.props.childComponentName == "DASHBOARD"){
				this.getGradeListDashboard(this.preSelectMenu);
			}else if(this.props.childComponentName == "HOME"){
				this.getGradeListTopic(this.preSelectMenu);
			}else{
				this.getGradeListTopic(this.preSelectMenu);
			}
		}else{
			this.setState({noProducts:true,view:noProductView});
			setTimeout(function(){	  			
				$(".page-content nav.side-navbar ul li").addClass("noclicks");
				me.sideBarDropdownChange();
			},300);			
			
		}
		
		try{
			var isCollapsed = (this.getAttribute("sidebar_collapsed") === "true");
			
			sidebar_props.collapsed = isCollapsed ||  sidebar_props.collapsed;

			if(sidebar_props.collapsed === true){
				//$(".page-content .content-inner").toggleClass("fullwidth");
				//$(".page-content nav.side-navbar").toggle();
				//$(".page-content nav.side-navbar").toggleClass('collapsed');
			}
		}catch(e){
			console.error(e);
		}

		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");
	}

	preSelectMenu(){
		let me = this;
		let routeMenuIndex = -1; // Second priority
		let attributeMenuIndex = -1; // First Priority
		if(menusJson && Object.keys(menusJson).length > 0){

			let accessMap = this.getUser().getAccessMap();
			let entlKey = accessMap[this.preferredProduct];
			this.entlKey = entlKey || this.entlKey;

			let allowedMenuIndex = 0;

			/**
			* Based on the product Id selected/preferred	
			*/
			let allowedMenus = [];
			let routeMenuIndices = [];
			let productMenuIndices = [];

			if(entlKey){
				let tmpAllowedIndex = -1;
				/**
				* IMPORTANT: Menu Selection does not happen here, only the possible indices of the possible
				* menuIds are captured and decided after this block.
				*/
				Object.values(menusJson).map((element, index) => {
					let menuAllowed = false;
					if(element){
						if(element && element.allowedEntlKeys && element.allowedEntlKeys.length > 0){
							if(~element.allowedEntlKeys.indexOf(entlKey) || entlKey === element.entlKey){
								allowedMenus.push(element);	
								menuAllowed = true;
								tmpAllowedIndex ++;
							}						
						}else{
							allowedMenus.push(element);
							menuAllowed = true;
							tmpAllowedIndex ++;
						} 

						if(menuAllowed){
							//Select the possible menu by product/entlKey - if available menu
							if(element.entlKey && (entlKey === element.entlKey)){
								productMenuIndices.push(tmpAllowedIndex);
							}

							//Select the possible menu by route
							if((element.route && (window.location.href).match(window.location.host + element.route)) || (element.value && (window.location.href).match(window.location.host + element.value)) ){
								routeMenuIndices.push(tmpAllowedIndex);
							}
						}					
					}
				});
			}else{
				allowedMenus = Object.values(menusJson);
			}

			if(sidebar_contest_host_driven && allowedMenus){
				let tempAllowedMenus = [];

				allowedMenus.map((menu, idx) => {
					if(menu.contestHosts && menu.contestHosts.length > 0){
						if(menu.contestHosts.includes(me.getContestHost())){
							tempAllowedMenus.push(menu);
						}						
					}else{
						tempAllowedMenus.push(menu);
					}
				})

				allowedMenus = tempAllowedMenus;
			}

			let menuPreSelected = false;
			/**
			* Deciding block - preselect menu
			*/
			if(entlKey){				
				if(routeMenuIndices.length > 0 && productMenuIndices.length > 0){
					for(let i=0; i< routeMenuIndices.length; i++){
						if(~productMenuIndices.indexOf(routeMenuIndices[i])){
							me.preferredMenuId = allowedMenus[routeMenuIndices[i]].id;
							menuPreSelected = true;
							break;
						}
					}
				}
				if(!menuPreSelected && routeMenuIndices.length > 0){
					menuPreSelected = true;
					me.preferredMenuId = allowedMenus[routeMenuIndices[0]].id;
				}
				/*if(! menuPreSelected && productMenuIndices.length > 0){
					menuPreSelected = true;
					me.preferredMenuId = allowedMenus[productMenuIndices[0]].id;
				}*/
			}

			if(!menuPreSelected){
	 		   //Case when entlKey or product is not availble, select by route	
	 		   if(allowedMenus && allowedMenus.length > 0){
	 		   	for(let i=0; i< allowedMenus.length; i++){
	 		   		if((allowedMenus[i].route && (window.location.href).match(window.location.host + allowedMenus[i].route)) || (allowedMenus[i].value && (window.location.href).match(window.location.host + allowedMenus[i].value)) ){
	 		   			me.preferredMenuId = allowedMenus[i].id;
	 		   			break;
	 		   		}	   	  	
	 		   	}
	 		   }
	 		}			

			/**
			*IMPORTANT: Set menu ID on Sidebar mount based on the selected state
			*/
			if(me.preferredMenuId){
				me.setState({selectedID: me.preferredMenuId});
			}						
		}
	}

	isMenuAllowedForContest(element){
		if(element && element.contestHostGroups && element.contestHostGroups.length > 0){
			try{
				if(window.contest_component_type[this.getContestHost()]){
					return element.contestHostGroups.includes(window.contest_component_type[this.getContestHost()].toUpperCase());	
				}
			}catch(e){
				console.error(e);
			}
			return false;
		}

		return true;
	}

	compoenentWillMount(){
		this.props.onRef(undefined);	  
	}

	gradeDropdownChange(gradeOption, prodOption){		
		this.selectedGradeOption = gradeOption;	
		this.selectedProductOption = prodOption;

		this.getProductList();		
	}

	gradeChange(event){
		var me = this;
		var selectedIndex = parseInt(event.currentTarget.dataset.index);
		this.selectedGradeOption = this.state.gradeArr[selectedIndex];

		this.getProductList();
	}

	gradeChangefromChooseGrade(gradeIndex, classId, prodIndex, entlKey){
		console.log("preferObj 1 : ", gradeIndex, prodIndex, entlKey);
		this.setPreferredDd();
		this.selectedGradeOption = this.state.gradeArr[gradeIndex];
		this.selectedProductOption = this.state.productArr[prodIndex];
		this.entlKey = entlKey;
		this.getProductList();
		this.hidegradeModal();
		this.saveProdPreference();
	}

	saveProdPreference(selectedClass=0, selectedAccessId=0, selectedEntlKey=null){
		let preferObj = null;
		try{
			preferObj = {
				grade : selectedClass || (this.selectedGradeOption && this.selectedGradeOption.classId ) ? this.selectedGradeOption.classId : null, 
				accessId : selectedAccessId || (this.selectedProductOption && this.selectedProductOption.id) ? this.selectedProductOption.id : null
			};

 			console.log("preferObj ::" , preferObj);
			if(typeof this.props.saveProdPreference === "function"){
				this.props.saveProdPreference(preferObj);
			}
		}catch(e){
			console.error("error occurred while saving preferObj:", preferObj ,e);
		}		
	}

	productChange(event){	
		var me = this;
		var selectedIndex = (event.currentTarget.dataset.index);
		this.selectedProductOption = (this.state.productArr && this.state.productArr.find((elem) => (elem.id == selectedIndex))) ? this.state.productArr.find((elem) => (elem.id == selectedIndex)) : null || this.selectedProductOption;		
		if(!this.selectedProductOption){
			if(event.currentTarget.dataset.value){
				this.leftmenuclick(event);
			}
			return;
		}else{
			this.setPreferredDd();
		}

		this.setState({selectedID:(event.currentTarget.dataset.id)});
		if(event.currentTarget.dataset.label.toLowerCase() == "lessons"){
			this.setState({selectedID:(event.currentTarget.dataset.id),lessonIconDisplay: lessonmenuiconwhite});			
			
		}else{
			this.setState({selectedID:(event.currentTarget.dataset.id),lessonIconDisplay: lessonmenuicon});
		}
		
		this.sideBarDropdownChange(true);
		let route= (event.currentTarget && event.currentTarget.dataset && event.currentTarget.dataset.route) ? event.currentTarget.dataset.route : "/landing";

		this.setPreferredMenu(() => {me.routeTo(route)});
	}

	routeTo(route){
		if(typeof this.props.routingMenus === "function"){
			this.props.routingMenus(route);
		}
	}

	setPreferredMenu(callBack){
		let me = this;
		try{
			this.gradeStore = {
				"grd":this.selectedGradeOption.value,
				"prod":this.selectedProductOption.value
				//"menuId":this.preferredMenuId
			}
			this.setAttribute(this.homeDropDownKey,JSON.stringify(this.gradeStore), () => {
				if(typeof callBack === "function"){
					callBack.apply(this);
				}
			});
		}catch(e){
			if(typeof callBack === "function"){
				callBack.apply(this);
			}
		}		
	}

	productsAvailableToAccess(){
		let me = this;
		var user = this.getUser();
		let accessMap = user.getAccessMap();
		if(user != null){
			var permissions = user.getEntlHistory();
			if(permissions != null && Object.keys(permissions).length > 0){
				for(var i in permissions){
					if(permissions[i] != null){
						var totalLevel = permissions[i].split(",").reduce(function(a,b){
							try{
								return parseInt(a) + parseInt(b);
							}catch(e){
								return 0;
							}
						});

						if(totalLevel > 0 || me.isServiceRoute(accessMap[i])){
							return true;
						}
					}
				}
			}
		}

		return false;
	}

	setPreferredDd(){
		try{
			var gradeStore = null;
			var prefStr = this.getAttribute(this.homeDropDownKey);
			if(prefStr)
				gradeStore = JSON.parse(prefStr);

			if(typeof gradeStore === "object"){
				this.preferredGrade = this.preferredGrade || gradeStore["grd"];
				//this.preferredMenuId = this.preferredMenuId || gradeStore["menuId"];
				this.preferredProduct = this.preferredProduct || gradeStore["prod"];
			}

		}catch(e){}
	}

	getGradeListDashboard(argCallBack){		
		var me = this;

		var callBack = function(response){
			var grades = response.classId;
			var products = response.accessId;
			
			var classDefnMap = response.classDefn;
			me.gradeProductMap =  response.gradeProdMap;
			me.classDefnMap = classDefnMap;

			var gradeArr =[];
			var preselectIndex = 0;
			let groupedGradesList = [];
			
			if(grades !== null && grades.length > 0){
				for(var i=0;i<grades.length;i++){
					if(grades[i] > 0){
						try{
							var dropDownLabel = me.rb(classDefnMap[grades[i]].className);

							if(classDefnMap[grades[i]] && classDefnMap[grades[i]].gradeId){
							/**
							* IMPORTANT: Replace classId with gradeId when available.
							* This is for grouped classes
							*/
							let gradeDisplayName = me.rb(classDefnMap[grades[i]].gradeDisplayName);
							
							classDefnMap[grades[i]]["label"] = gradeDisplayName;
							classDefnMap[grades[i]]["value"] = grades[i];
							gradeArr.push(classDefnMap[grades[i]]);
							
						}else{
							classDefnMap[grades[i]]["label"] = dropDownLabel;
							classDefnMap[grades[i]]["value"] = grades[i];
							gradeArr.push(classDefnMap[grades[i]]);
						}

					}catch(e){
					}
				}
			}
		}

		if(gradeArr && gradeArr.length > 0){
			for(var i=0; i< gradeArr.length; i ++){
				if(gradeArr[i].value == (me.preferredGrade)){ 
					preselectIndex = i;
				}
			}

		}


		me.selectedGradeOption = gradeArr[preselectIndex];
		me.setState({gradeArr:gradeArr});
		me.getProductList(argCallBack);		
	}

	this.getClassNamesDashboard(callBack);
}
getClassNamesDashboard(callBack){
	var me = this;
	var callBackSuccess = function(response){
		me.comboNamesLoaded = true;
		callBack.apply(this,[response]);
	}

	var callBackFailure = function(error){
		me.showAlert(me.rb("503.title"),me.rb("503.msg"));
	}

	new HmAjax(this.getUrlFor("DASH_COMBO_DATA")).get(callBackSuccess,callBackFailure);	
}
getGradeListTopic(argCallBack){		
	var me = this;
	var gradeProductMap = this.gradeProductMap;
	var entlhistory = this.getUser().getEntlHistory();

	for(var i in entlhistory){
		try{
			if(entlhistory[i] !== undefined && entlhistory[i] !== null && entlhistory[i].length > 0){
				var tempKeysArr =  entlhistory[i].split(",");
				if(tempKeysArr.length > 0){
					for(var j=0;j<tempKeysArr.length ; j++){
						var existingArr = gradeProductMap[tempKeysArr[j]];
						if(existingArr === undefined || existingArr === null){
							existingArr = [];
						}
						existingArr.push(i);

						gradeProductMap[tempKeysArr[j]] = existingArr;
					}
				}
			}
		}catch(e){
			console.error(e);
		}

	}

	this.gradeProductMap = gradeProductMap;

	let groupedGradesList = [];

	var grades = Object.keys(gradeProductMap);
	var callBack = function(classDefnMap){
		var gradeArr =[];
		var preselectIndex = 0;
		me.classDefnMap=classDefnMap;

		if(grades !== null && grades.length > 0){
			for(var i=0;i<grades.length;i++){
				if(grades[i] > 0){
					try{
						var dropDownLabel = me.rb(classDefnMap[grades[i]].className);
						if(classDefnMap[grades[i]] && classDefnMap[grades[i]].gradeId){
							/**
							* IMPORTANT: Replace classId with gradeId when available.
							* This is for grouped classes
							*/							

							let gradeDisplayName = me.rb(classDefnMap[grades[i]].gradeDisplayName);
							
							classDefnMap[grades[i]]["label"] = gradeDisplayName;
							classDefnMap[grades[i]]["value"] = grades[i];
							gradeArr.push(classDefnMap[grades[i]]);
							
						}else{
							classDefnMap[grades[i]]["label"] = dropDownLabel;
							classDefnMap[grades[i]]["value"] = grades[i];
							gradeArr.push(classDefnMap[grades[i]]);

						}


					}catch(e){
					}
				}
			}
		}

		if(gradeArr && gradeArr.length > 0){
			for(var i=0; i< gradeArr.length; i ++){
				if(gradeArr[i].value == (me.preferredGrade)){ 
					preselectIndex = i;
				}
			}

		}

		me.selectedGradeOption = gradeArr[preselectIndex];
		me.setState({gradeArr:gradeArr});
		me.getProductList(argCallBack);

	}

		// if(this.props.childComponentName == "HOME" || this.props.childComponentName== "DASHBOARD"){
		// 	this.getClassNamesTopic(grades, callBack);
		// }else{
			this.getClassNamesTopic(grades, callBack);
		//}
	}

	getClassNamesTopic(classIds,callBack){
		var me = this;
		var callBackSuccess = function(response){
			me.comboNamesLoaded = true;
			if(typeof callBack === "function"){
				callBack.apply(this,[response]);
			}
		}

		var callBackFailure = function(error){
			me.showAlert(me.rb("503.title"),me.rb("503.msg"));
		}

		let entlKey = this.getUser().getAccessMap()[this.preferredProduct];

		let url = null;
		if(entlKey && window.class_defn_list_entls && window.class_defn_list_entls.length > 0){
			for(let i=0; i< window.class_defn_list_entls.length; i++){
				if(entlKey.match(window.class_defn_list_entls[i].replace("|","\\|"))){
					url = me.getUrlFor("CLASS_DEFN");
					break;
				}
			}
		}

		/**
		 * IMPORTANT: entlKey is not used now. This will come in handy with ChooseGrade is to be populated with 
		 * Class Names from Schema other than PLP DB. Because the URL configured for "CLASS_DEFN" fetches from PLP DB
		 * NOTE: Use an else condition and new URL to get list relevant for particular entlKey
		 */
		 if(url){
		 	new HmAjax(url,classIds).post(callBackSuccess,callBackFailure);	
		 }else{
		 	//This just for the sake of making the sidebar work. me.comboNamesloaded
		 	me.comboNamesLoaded = true;
		 	if(typeof callBack === "function"){
		 		callBack.apply(this);
		 	}		 	
		 }		 
		}

		getProductList(argCallBack){
			var preselectIndex = 0;
			var gradeProductMap = this.gradeProductMap;

			var permissionMap = this.getUser().getPermissions();
			var permissions = (this.selectedGradeOption) ? gradeProductMap[this.selectedGradeOption.value] : [];
			var accessMap = this.getUser().getAccessMap();
			let reverseAccessMap = this.getUser().getReverseAccessMap();
			var lessonIconDisplay = lessonmenuicon;
			if(permissions.length > 0){
				var productArr = [];

				for(var i=0;i<permissions.length;i++){

					var classCode = this.classDefnMap[this.selectedGradeOption.value].classCode;
					var board = this.classDefnMap[this.selectedGradeOption.value].board


					var label = this.rb(accessMap[permissions[i]] + "-" + classCode + "-" + board  ) || this.rb("label-"+permissions[i] + "-" + classCode + "-" + board);

					if((label === accessMap[permissions[i]] + "-" + classCode + "-" + board) || (label === "label-"+permissions[i] + "-" + classCode + "-" + board)){
						label = this.rb(accessMap[permissions[i]]+"-menu") || this.rb("label-"+permissions[i]);
					}


					var materilkey = 'assignment';
					if(permissions[i] == 3){
						materilkey = 'ondemand_video';
					}

					if(reverseAccessMap){
						permissions[i] = reverseAccessMap[accessMap[permissions[i]]];
					}

					productArr.push({entlKey:accessMap[permissions[i]],"label":label,"value":permissions[i],'id':permissions[i],'materialkey':materilkey});
					if(permissions[i] == parseInt(this.preferredProduct)){

						preselectIndex = i;
						if(parseInt(this.preferredProduct) == 3){  
							lessonIconDisplay = lessonmenuiconwhite;
						}
					}

				}				
				this.selectedProductOption = productArr[preselectIndex];		

				var selectedProductId = this.selectedProductOption.id;
				let prodClicked = false;
				if(this.availableMenuIds && this.availableMenuIds.has(this.preferredMenuId)){
					selectedProductId = this.preferredMenuId;
	}/*else if(this.props.childComponentName == "DASHBOARD"){
		selectedProductId = 1001;
		lessonIconDisplay = lessonmenuicon;
	}*/else{
		prodClicked = true;
	}

	if(!prodClicked && this.selectedMenu && this.selectedMenu.entlKey){
		prodClicked = true;
	}

	this.setState({productArr:productArr,selectedID:  this.preferredMenuId || selectedProductId,lessonIconDisplay:lessonIconDisplay});			
	this.sideBarDropdownChange(prodClicked);
	if(argCallBack && typeof argCallBack === "function"){
		argCallBack.apply(this);
	}
}else if(this.preferredProduct || Object.keys(permissionMap).length > 0){
	if(argCallBack && typeof argCallBack === "function"){
		argCallBack.apply(this);
	}
}else{
	this.setState({message:this.rb("home.not_entitled"), view:messageView});
	this.sideBarDropdownChange();
	this.showAlert("",this.rb("home.not_entitled"));
}

}

openProfile(){
	try{
		this.props.myProps.history.push("/settings");
	}catch(e){

	}

}

profilePicToggle(enable){
	var elems = document.getElementsByClassName("avatar");

	if(enable){
		if(elems && elems.length > 0){
			elems[0].classList.add("active");
			elems[0].classList.remove("inactive")
		}
	}else{
		if(elems && elems.length > 0){
			elems[0].classList.add("inactive");
			elems[0].classList.remove("active")
		}
	}

}

sideBarDropdownChange(isProductClicked=false){
	this.props.sideBarDropdownChange(this.selectedGradeOption,this.selectedProductOption,this.comboNamesLoaded,this.state,isProductClicked)	
}

leftmenuclick(element){
	let me = this;
	let route = element.currentTarget.dataset.value;

	me.setState({selectedID:(element.currentTarget.dataset.id),lessonIconDisplay:lessonmenuicon});

	this.setPreferredMenu(() => {
		me.routeTo(route);
	});
	/*this.setState({selectedID:(event.currentTarget.dataset.id),lessonIconDisplay:lessonmenuicon});
	this.props.routingMenus(event.currentTarget.dataset.value);*/
}

deleteCurrentImage(){
	this.setState({imageLoaded:false});
}

loadCurrentImage(){
	var me = this;
	var success = function(response){
		if(response && response.imgUrl){
			me.setState({imagePreviewUrl:response.imgUrl, imageLoaded:true});
		}
	} 

	var failure = function(err){

	}

	new HmAjax(this.getUrlFor("PROFILE_PIC")).get(success, failure);
}

setCurrentImage(imageUrl){
	this.setState({imagePreviewUrl:imageUrl, imageLoaded:true});
}

	/*
	* IMPORTANT: This is the place to modify the menus to be rendered dynamically - Shyam
	*/
	getSideBarMenus(){
		var me = this;
		let elements = menus.map((element,index) => {   
			return (<li key={index} className={me.rb(element.label)+" leftmenu "+((this.state.selectedID) === (element.id) ? "active" : "")} onClick={this.leftmenuclick.bind(this)} data-id={element.id} data-value={element.value}><a> <i className="material-icons">{element.materialkey}</i> <span className="leftmenutxt">{me.rb(element.label)}</span> </a></li>)
		})
		return elements;

	}
	showGradeSelection(){		
		if(this.getProductCount() < 2){
			return;
		}

		this.setState({ grademodalShow: true, grademodalContent:this.getGradeMoalContent(), grademodalTitle:""});
	}

	getProductCount(){
		let orphanClassIds = new Set();
		let groupedGradeIds = new Set();
		let tempGradeArr = this.state.gradeArr;
		if(tempGradeArr && tempGradeArr.length > 0){
			for(let i =0; i<tempGradeArr.length; i++){
				if(tempGradeArr[i] && tempGradeArr[i].classId){
					if(!isNaN(tempGradeArr[i].gradeId) && tempGradeArr[i].gradeId > 0){
						groupedGradeIds.add(tempGradeArr[i].gradeId);
					}else if(!isNaN(tempGradeArr[i].classId) && tempGradeArr[i].classId > 0){
						orphanClassIds.add(tempGradeArr[i].classId);
					}
				}
			}
			return (orphanClassIds.size + groupedGradeIds.size);
		}else{
			return 0;
		}

		//return (this.state.gradeArr) ? this.state.gradeArr.length : 0;
	}
	isServiceRoute(entlKey){
		let me = this;
		let serviceRoutesEntls = window.serviceRoutesEntls || [];
		if(entlKey && serviceRoutesEntls && serviceRoutesEntls.length > 0){
			for(let i=0; i< serviceRoutesEntls.length; i++){
				if(entlKey.match(serviceRoutesEntls[i].replace("|","\\|"))){
					me.preferredProduct = entlKey;
					return true; 
				}
			}
		}

		return false;
	}

	getGradeMoalContent(){		
		return (<ChooseGrade gradeArr={this.state.gradeArr} gradeProductMap={this.gradeProductMap}  selectedGradeOption={this.selectedGradeOption} selectedProductOption={this.selectedProductOption} gradeChangefromChooseGrade={this.gradeChangefromChooseGrade}/>);
	}
	hidegradeModal(){
		this.setState({ grademodalShow: false, grademodalContent:"", grademodalTitle:""});
	}
	loadgradeModalContent(){
		if (this.state.grademodalContent != "") {
			return(
				<div>
				{this.state.grademodalContent}
				</div>
				)
			}
		}

		getLabelByBoard(element){
			let board = (element && element.board) ? element.board : null;

			if(board && board.toUpperCase() === "RSA"){
				if(element && element.classDescription && element.classDescription.length > 0){
					return this.rb(element.classDescription);
				}else if(element && element.className && element.className.length > 0){
					return this.rb(element.className);
				}			

			}

			return null;
		}


		getGradeMenus(){
			if(!this.selectedGradeOption){
				return;
			}

			let entlKey = this.getUser().getAccessMap()[this.preferredProduct];

			let classNamesAllowedEntls = window.choose_grade_allowed || [];

			let fetchClassNames = false;
			if(entlKey && classNamesAllowedEntls && classNamesAllowedEntls.length > 0){
				for(let i =0; i< classNamesAllowedEntls.length; i++){
					if(classNamesAllowedEntls[i] && entlKey.match(classNamesAllowedEntls[i].replace("|","\\|"))){
						fetchClassNames = true;
						break;
					}
				}
			}else if(!entlKey){
				fetchClassNames = false;
			}else{
				fetchClassNames = true;
			}

			var me = this;

			let gradeMenuTxt = this.getLabelByBoard(this.selectedGradeOption);

			if(gradeMenuTxt && gradeMenuTxt.length > 0){
				//Do nothing
			}else if(this.selectedGradeOption && this.selectedGradeOption.gradeDisplayName && this.selectedGradeOption.gradeDisplayName.length > 0 && this.selectedGradeOption.gradeDisplayName !== "null"){
				gradeMenuTxt = this.rb(this.selectedGradeOption.gradeDisplayName);
			}else if(this.selectedGradeOption && this.selectedGradeOption.classDescription && this.selectedGradeOption.classDescription.length > 0 && this.selectedGradeOption.classDescription !== "null"){
				return this.rb(this.selectedGradeOption.classDescription);
			}else{
				//Older approach
				gradeMenuTxt = this.rb(this.selectedGradeOption.label);
			}
			let grdTxt = (gradeMenuTxt.replace(/\s/g,'')).toLowerCase();
			let addncls = ("sb_"+grdTxt).toLowerCase();
			const singleGradeMenuStyle = {pointerEvents:"none",opacity:0.7}

			if(fetchClassNames && this.getProductCount() < 2){
				return (
					<li className="" style={singleGradeMenuStyle}>
					<a className="" href="#" id="navbardrop">
					<i className="material-icons">school</i> 
					<span className={"leftmenutxt "+addncls}>{gradeMenuTxt}</span>
					</a>    
					</li>
					);
			}else if(fetchClassNames && this.getProductCount() > 0){
				return (
					<li className="" onClick={this.showGradeSelection.bind(this)}>
					<a className="" href="#" id="navbardrop">
					<i className="material-icons">school</i> 
					<span className={"leftmenutxt "+addncls}>
					<span className={grdTxt}>{gradeMenuTxt}</span>
					<i className="material-icons absolute">arrow_right</i> </span>
					</a>	      
					</li>
					);
			}

		}
		handleMouseOver(event) {		
			this.setState({
				lessonIconDisplay: lessonmenuiconwhite
			});    
		}

		handleMouseOut(event) {
			if(!$(event.currentTarget).hasClass("active")){
				this.setState({
					lessonIconDisplay: lessonmenuicon
				});
			}

		}

		isLessonTabAvailable(){
				//This is restricted to only Mobile check for now
				return this.showFormobile();
			}

			showFormobile(){
				var isMobileOrTab = this.isTab() || this.isMobile();

				var lessonLockForGrades =  window.lessonLockForGrades || [];
				var gradeVal = !isNaN(this.selectedGradeOption.value) ? Number(this.selectedGradeOption.value) : 0;

				return !(lessonLockForGrades.indexOf(gradeVal) > -1 && isMobileOrTab);
			}

	// getProductMenus(){
	// 	var me = this;

	// 	let elements = this.state.productArr.map((element,index) => {   
	// 		if(element.label.toLowerCase() == "lessons"){
	// 			return (<li key={index} className={element.label+" leftmenu "+((this.state.selectedID) === (element.id) ? "active" : "")} data-index={index} data-id={element.id} data-value={element.value} data-label={element.label} onClick={this.productChange.bind(this)} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}><a> <i className="va-inherit"><img className="material-icons" src={this.state.lessonIconDisplay} /></i> <span className="leftmenutxt">{element.label}</span> </a></li>)
	// 		}
	// 		else{
	// 			return (<li key={index} className={element.label+" leftmenu "+((this.state.selectedID) === (element.id) ? "active" : "")} data-index={index} data-id={element.id} data-value={element.value} data-label={element.label} onClick={this.productChange.bind(this)}><a> <i className="material-icons">{element.materialkey}</i> <span className="leftmenutxt">{element.label}</span> </a></li>)
	// 		}

	// 	})
	// 	return elements;
	// }
	showHideLeftMenu(){
		$(".page-content .content-inner").toggleClass("fullwidth");
		$(".page-content nav.side-navbar").toggle();
		$(".page-content nav.side-navbar").toggleClass('collapsed');

		var isCollapsed = $('nav.side-navbar').hasClass('collapsed');


		if(typeof isCollapsed === "boolean"){
			this.setAttribute("sidebar_collapsed",isCollapsed.toString());	
		}


		sidebar_props.collapsed =  $('nav.side-navbar').hasClass('collapsed');
		UserStorageUtil.storeSessionItem("sidebar_collapsed",sidebar_props.collapsed);

	}

	getMenusFromJson(){
		this.availableMenuIds = new Set();
		let me = this;
		let accessMap = me.getUser().getAccessMap();
		let reverseAccessMap = me.getUser().getReverseAccessMap();

		if(menusJson && Object.keys(menusJson).length > 0){
			let routeMenuIndex = -1; // Second priority
			let attributeMenuIndex = -1; // First Priority

			Object.values(menusJson).map((element, index) => {
				let menuAvailable = false;
				if(element && element.allowedEntlKeys && element.allowedEntlKeys.length > 0 && me.state.productArr && me.state.productArr.length > 0){
					me.state.productArr.map((prod, idx) => {
						//console.warn("lalala menus loop::" ,me.state.productArr," : ",index);
						if(prod && prod.entlKey &&  (element.allowedEntlKeys && element.allowedEntlKeys.length > 0 && (~element.allowedEntlKeys.indexOf(prod.entlKey)))){
							menuAvailable = true;
							return;
						}
					});
				}else if(element){
					menuAvailable = true;
				}
				/**
				* VERY IMPORTANT: This approach will be dangerous for menus with
				* same routes. IN which case, it better to go with the menuId
				*/
				//Check if the Sidebar Menu is to be activated based on Route
				if(menuAvailable && element.route && (window.location.href).match(window.location.host + element.route)){
					routeMenuIndex = index;
				}

				//Check if the Sidebar menu is to be activated based on selected MenuId from state or attribute
				if(menuAvailable && (me.state.selectedID === element.id || me.preferredMenuId === element.id)){
					attributeMenuIndex = index;
				}

			});


			return Object.values(menusJson).map((element, index) => {
				let menuAvailable = false;

				if(element && element.allowedEntlKeys && element.allowedEntlKeys.length > 0){
					if(me.state.productArr && me.state.productArr.length > 0){
						me.state.productArr.map((prod, idx) => {
						//console.warn("lalala menus loop::" ,me.state.productArr," : ",index);
						if(prod && prod.entlKey &&  (element.allowedEntlKeys && element.allowedEntlKeys.length > 0 && (~element.allowedEntlKeys.indexOf(prod.entlKey)))){
							menuAvailable = true;
							return;
						}
					});
					}else if(me.getUser().getEntlHistory() && Object.values(me.getUser().getEntlHistory()).length > 0){
						let userEntlHistory = me.getUser().getEntlHistory();
						let allowedEntlKeys = element.allowedEntlKeys;

						for(let i=0; i< allowedEntlKeys.length; i++){
							if(userEntlHistory.hasOwnProperty(me.getUser().getReverseAccessMap()[allowedEntlKeys[i]])){
								menuAvailable = true;
								break;
							}
						}

						/*for(let i in userEntlHistory){
							try{
								let tempArr = userEntlHistory[i].split(",");

								if(tempArr && ((tempArr.length > 0 && Number(tempArr[0]) > 0) || (tempArr.length > 1 && Number(tempArr[1]) > 0) || me.isServiceRoute(accessMap[i]))){
									menuAvailable = true;
									break;
								}								
							}catch(e){
								console.error(e);
							}			
						}*/
					}
				}else{
					menuAvailable = true;
				}
				
				if(menuAvailable && sidebar_contest_host_driven){
					menuAvailable = (menuAvailable && me.isMenuAllowedForContest(element));
				}

				if(element && menuAvailable){
					if(reverseAccessMap && element.entlKey && element.entlKey.length > 0 && !isNaN(reverseAccessMap[element.entlKey])){
							//element.id = reverseAccessMap[element.entlKey];
							//element.index = element.id;
							//element.value = reverseAccessMap[element.entlKey];
							element.index = reverseAccessMap[element.entlKey];
						}
						me.availableMenuIds.add(element.id);	 

						let activeMenuCls = "";

						if(attributeMenuIndex > -1){
							activeMenuCls = (!activeMenuCls && attributeMenuIndex === index) ? "active" : "";
						}else if(routeMenuIndex > -1){
							activeMenuCls = (routeMenuIndex === index) ? "active" : "";
						}		

						let additcls = "sb_"+element.id;
						if(element.img){
							return (<li key={index} onClick={me.goTo}  className={element.label+" leftmenu "+(activeMenuCls)+" "+additcls} data-route={element.route} data-index={element.index} data-id={element.id} data-value={element.value} data-label={element.label}><a>
						{/* <i className="material-icons">{element.materialkey}</i> */}
						<img src={"/images/contest/"+element.img} alt={element.id}></img>
						<span className="leftmenutxt contest">{element.label}</span>{(() =>{
							if(element.externalLink){
								return(<i style={{float:'right'}} class="material-icons external">open_in_new</i>
									)
								}
							})()
						}</a></li>);
					}else{
						return (<li key={index} onClick={me.goTo}  className={element.label+" leftmenu "+(activeMenuCls)+" "+additcls} data-route={element.route} data-index={element.index} data-id={element.id} data-value={element.value} data-label={element.label}><a> <i className="material-icons">{element.materialkey}</i> <span className="leftmenutxt contest">{element.label}</span>{(() =>{
							{/* <i className="material-icons">{element.materialkey}</i> */}
							if(element.externalLink){
								return(<i style={{float:'right'}} class="material-icons external">open_in_new</i>
								)
							}
						})()
					}</a></li>);
				}

			}	

		});
	}
}

goTo(element){
	this.selectedMenu = element;
	this.preferredMenuId = element.currentTarget.dataset.id; 
	let route = element.currentTarget.dataset.route || '';

	let handlerKey = (menusJson && menusJson[this.preferredMenuId] && menusJson[this.preferredMenuId].handlerKey) ? menusJson[this.preferredMenuId].handlerKey : null;
	let externalLink = (menusJson && menusJson[this.preferredMenuId] && menusJson[this.preferredMenuId].externalLink) ? menusJson[this.preferredMenuId].externalLink : false;
	
	if(externalLink && route!==""){
		window.open(route,"_blank");
	}
	else if(externalLink){
		HmEventRegistry.fireEvent(handlerKey);
	}else if(route!=''){
		this.productChange(element);
	}
	else{
		this.leftmenuclick(element);
	}
}


/*
* IMPORTANT: This is the place to modify the menus to be rendered dynamically - Shyam
*/
renderSidebarTab(){
	var me=this;
	return (
		<ul className="list-unstyled">	
		{( ()=> {
			if(me.comboNamesLoaded){
				return (
					<div>
					{me.getGradeMenus()}
				{/* {me.getProductMenus()} */}
				{me.getMenusFromJson()}
				</div>
				);	
			}

		})()}

	{/* {me.getSideBarMenus()} */}
	</ul>
	)
			}

			renderHumburger(){
				return (
					<div className="plpsidemenu showhidemenu">
					<a id="toggle-btn" href="#" className="menu-btn active" onClick={this.showHideLeftMenu}>
					<i className="material-icons">menu</i>
					</a>
					</div>	
					)
				}

				render() {
					var headerImgStyle = {			 
						backgroundImage: 'url(' + profileBg + ')',
						backgroundSize:"cover"
					};

					return (
					<div className="pos_relative">

					{this.renderHumburger()}

					<nav className="side-navbar">			  

					{this.renderSidebarTab()}

					</nav>

					<div>							
					<TestTakingModalComponent visible={this.state.grademodalShow} dialogClassName="fullwidthdiag grademodal">
					<div className="modal-header bg-purple">
					<div className="modal-title">
					{this.state.grademodalTitle}
					</div>
					<div className="close" onClick={this.hidegradeModal.bind(this)} aria-label="Close">
					<span aria-hidden="true"><i className="material-icons">close</i></span>
					</div>
					</div>
					<div className="modal-body testModalBody">
					{this.loadgradeModalContent()}
					</div>							
					</TestTakingModalComponent>
					</div>

					</div>
					);
				}
			}

			ComponentRegistry.register("Sidebar",Sidebar);


// WEBPACK FOOTER //
// ./src/views/common/Sidebar.js